import {SalesRepReportContext} from '../context'
import { useGetRepresantetives } from '../hooks/useGetRepresantetives'
import useGetSalesRepReport from '../hooks/useGetSalesRepReport'
import SalesRepReportHeader from '../sections/headers/SalesRepReportHeader'
import SalesRepReportTable from '../sections/table/SalesRepReportTable'

const SalesRepReport = () => {
  const {
    salesRepData,
    isLoading,
    filters,
    searchValue,
    onSearch,
    onSortingChange,
    onSalesRepFilterChange,
  } = useGetSalesRepReport()

  const {Representatives, loading: RepresentativesLoading} = useGetRepresantetives()

  const contextValue = {
    salesRepData,
    isLoading,
    filters,
    searchValue,
    onSearch,
    onSortingChange,
    onSalesRepFilterChange,

    Representatives,
    RepresentativesLoading,
  }

  return (
    <SalesRepReportContext.Provider value={contextValue}>
      <SalesRepReportHeader />
      <SalesRepReportTable />
    </SalesRepReportContext.Provider>
  )
}

export default SalesRepReport
